/**
 * Reuseable collections for dropdowns
 **/

var collections =
{
    /**
     * Minutes for pause
     *
     * @param {Boolean}
     * @param {Boolean} withUnit
     * @return {{}}
     */
    pause(withUnit)
    {
        let pauses = {},
            unit = (withUnit)? ' m' : '';

        // 0 = dash (–)
        pauses[0] = '\u2014';

        for (let i = 15; i <= 120; i+=15)
        {
            pauses[i.toString() + unit] = i.toString() + unit;
        }

        return pauses;
    },

    /**
     * Minutes for timepicker dropdown
     *
     * @param {Boolean} withUnit
     * @returns {{}}
     */
    minutes(withUnit)
    {
        let minutes = {},
            unit = (withUnit)? ' m' : '';

        for (let i = 0; i <= 60; i+=15)
        {
            minutes[i.toString() + unit] = (i < 10)? '0' + i: i.toString() + unit;
        }

        return minutes;
    },

    /**
     * Hours for timepicker dropdown
     *
     * @returns {{}}
     */
    hours(withUnit)
    {
        let hours = {},
            unit = (withUnit)? ' h' : '';

        for (let i = 0; i < 24; i++)
        {
            hours[i.toString() + unit] = (i < 10)? '0' + i: i.toString() + unit;
        }

        return hours;
    },

    /**
     * Returns collection prepared for v-select component input
     *
     * @param selection
     * @param {Collection} collection, expects collection of objects having name and id
     */
    tags(selection, collection)
    {
        let _collection = [];

        collection.forEach(item =>
        {
            _collection.push({
                label: item.name,
                value: item.id,
            });
        });

        _collection = _.sortBy(_collection, 'label');

        return _.differenceBy(_collection, selection, 'value');
    },

    /**
     * Weeks for dropdwon
     *
     * @returns {{}}
     */
    weeks()
    {
        let weeks = {};

        for (let i = 1; i < 54; i++)
        {
            weeks[i] = i;
        }

        return weeks;
    },

    /**
     * Returns an object of years based on starting point
     *
     * @param {mixed} present representing base year to calculate with. If boolean (true) year of the present year is used
     * @param {number} back years to go back
     * @param {number} future years to go into the future
     * @returns {{}}
     */
    years(present, back, future)
    {
        let today = new Date().getFullYear(),
            years = {};

        if (typeof present != 'boolean' && typeof present != 'undefined' || present === false) today = present;

        for (let i = (back * -1); i <= future; i++)
        {
            years[(today+i).toString()] = (today + i);
        }

        return years;
    },
}

export default collections;



// WEBPACK FOOTER //
// ./src/js/helpers/collections.js